import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/css/bootstrap-grid.rtl.min.css';
import './index.css';
import App from './App';


const root = ReactDOM.createRoot(document.getElementById('main'));
root.render(
    <StrictMode>
        <App />
    </StrictMode>
);
